import { type ViewData, type ViewOrder } from '@terros/common'

type InsertViewInput = {
  views: ViewData[]
  view: ViewData
  order: ViewOrder
}

export function insertViewInOrder({ views, view, order }: InsertViewInput): ViewData[] {
  const positionedIds = new Set(order)

  function comesAfterNewView(candidate: ViewData): boolean {
    if (positionedIds.has(candidate.viewId)) return false
    const nameOrder = view.name.localeCompare(candidate.name)
    if (nameOrder !== 0) return nameOrder < 0
    return view.viewId.localeCompare(candidate.viewId) < 0
  }

  const nextIndex = views.findIndex(comesAfterNewView)
  const insertAt = nextIndex < 0 ? views.length : nextIndex
  return [...views.slice(0, insertAt), view, ...views.slice(insertAt)]
}
